import React, { useState } from 'react';
import { Container } from '../components/ui/Container';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { Mail, MessageSquare, Phone } from 'lucide-react';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="bg-white" data-id="element-356">
      {/* Hero */}
      <div className="bg-gray-900 py-20 lg:py-32 text-center text-white" data-id="element-357">
        <Container data-id="element-358">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl mb-6" data-id="element-359">
            Get in Touch
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-360">
            Have questions? We'd love to hear from you. Send us a message and
            we'll respond as soon as possible.
          </p>
        </Container>
      </div>

      {/* Contact Form & Info */}
      <section className="py-24" data-id="element-361">
        <Container data-id="element-362">
          <div className="grid lg:grid-cols-2 gap-16" data-id="element-363">
            {/* Contact Info */}
            <div data-id="element-364">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-365">
                Contact Information
              </h2>
              <p className="text-gray-600 mb-8" data-id="element-366">
                Reach out to us through any of these channels, and we'll get
                back to you within 24 hours.
              </p>

              <div className="space-y-6" data-id="element-367">
                <div className="flex items-start" data-id="element-368">
                  <div className="flex-shrink-0" data-id="element-369">
                    <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600" data-id="element-370">
                      <Mail className="h-6 w-6 text-white" data-id="element-371" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-372">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-373">Email</h3>
                    <p className="mt-1 text-gray-600" data-id="element-374">info@acciom.co.uk</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-375">
                  <div className="flex-shrink-0" data-id="element-376">
                    <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600" data-id="element-377">
                      <MessageSquare className="h-6 w-6 text-white" data-id="element-378" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-379">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-380">
                      Live Chat
                    </h3>
                    <p className="mt-1 text-gray-600" data-id="element-381">
                      Available Mon-Fri, 9am-5pm GMT
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-382">
                  <div className="flex-shrink-0" data-id="element-383">
                    <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600" data-id="element-384">
                      <Phone className="h-6 w-6 text-white" data-id="element-385" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-386">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-387">
                      Support
                    </h3>
                    <p className="mt-1 text-gray-600" data-id="element-388">
                      Priority support for Pro & Agency plans
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-12 p-6 bg-gray-50 rounded-lg" data-id="element-389">
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-390">
                  Flowsense by Acciom Limited
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-391">
                  We're committed to helping brands optimize their email
                  marketing flows with AI-powered insights.
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div data-id="element-392">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-393">
                <div data-id="element-394">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-395">
                    Name
                  </label>
                  <Input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required placeholder="Your name" data-id="element-396" />
                </div>

                <div data-id="element-397">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-398">
                    Email
                  </label>
                  <Input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required placeholder="your@email.com" data-id="element-399" />
                </div>

                <div data-id="element-400">
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-401">
                    Subject
                  </label>
                  <Input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required placeholder="How can we help?" data-id="element-402" />
                </div>

                <div data-id="element-403">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-404">
                    Message
                  </label>
                  <textarea id="message" name="message" rows={6} value={formData.message} onChange={handleChange} required placeholder="Tell us more about your question or feedback..." className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-405" />
                </div>

                <Button type="submit" size="lg" className="w-full" noGradient data-id="element-406">
                  Send Message
                </Button>
              </form>
            </div>
          </div>
        </Container>
      </section>
    </div>;
}